import { useContext } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import H3 from '@base/H3/H3';
import H5 from '@base/H5/H5';
import { Spacings } from '@styles/index';
import Paper from '@base/Paper/Paper';
import dates from '@utils/dates';
import UnderlineLink from '@comp/UnderlineLink/UnderlineLink';
import H4 from '@base/H4/H4';

const Wrapper = styled(Paper)`
  width: 100%;
  padding: ${Spacings.SPACING_12B} ${Spacings.SPACING_17B};
  border-radius: ${Spacings.SPACING_2B};
  background-image: ${({ $images }) => `url(${$images})`};
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: contain;
  & > :last-child {
    margin-top: ${Spacings.SPACING_10B};
  }
  @media (max-width: 70.95em) {
    padding: 24px 32px;
  }
  @media (max-width: 47.95em) {
    padding: 25px 18px 32px;
    background-size: 283px 204px;
    background-position-x: 122%;
  }
  @media (max-width: 400px) {
    background-position-x: 82%;
  }
`;

const Title = styled(H3)`
  width: 380px;
  margin-top: ${Spacings.SPACING_7B};
  margin-bottom: ${Spacings.SPACING_4B};
  @media (max-width: 47.95em) {
    font-size: 15px;
    width: 225px;
  }
`;

const Date = styled.span`
  color: ${({ $color }) => $color};
`;

const Logo = styled.img`
  height: 50px;
  width: 160px;
  margin-left: -${Spacings.SPACING_6};
`;

const CombatBanner = ({ data, bannerDetails }) => {
  const theme = useContext(ThemeContext);
  const { banner_pngs, goal, date } = data || {};
  return (
    <Wrapper $images={banner_pngs?.web.castle}>
      <Logo src={banner_pngs?.web.logo} alt="logo" />
      <Title color={theme.colors.fontGrey}>{bannerDetails.description}</Title>
      <H5 color={theme.colors.fontGrey}>
        <span>Next Combat on </span>
        <Date $color={theme.colors.blue}>
          {dates.fullDateWithTime(date, ' at ')}
        </Date>
      </H5>
      <UnderlineLink
        href="/combat/[goalSlug]/[goalUID]"
        as={`/combat/${goal?.slug || 'a'}/${goal?.uid}`}
        color={theme.colors.blue}
      >
        <H4 color={theme.colors.blue}>Learn more</H4>
      </UnderlineLink>
    </Wrapper>
  );
};

export default CombatBanner;

CombatBanner.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  bannerDetails: PropTypes.objectOf(PropTypes.any)
};

CombatBanner.defaultProps = {
  data: {},
  bannerDetails: {}
};
